import { FC } from 'react';
import { IICartGroupBar } from 'mod/cart/interface';
import { Checkbox } from 'antd';
import type { CheckboxChangeEvent } from 'antd/lib/checkbox';
import OrderProductTag from '@base/snippets/OrderProductTag';
import styles from './cartMenu.module.less';

type IGroupHeaderProps = {
    data: IICartGroupBar;
    isBatchList: boolean;
    groupCheckAll: boolean;
    onGroupCheckAll: (e: CheckboxChangeEvent) => void;
};

export const GroupHeader: FC<IGroupHeaderProps> = props => {
    const { data, isBatchList, groupCheckAll, onGroupCheckAll } = props;
    const { tag, tips } = data;

    return !tag && !tips ? null : (
        <div className={styles['group-header']}>
            <div className={styles['col-checkbox']}>
                <Checkbox
                    // value={`group-${gr}`}
                    checked={groupCheckAll}
                    onChange={onGroupCheckAll}
                    className={isBatchList ? styles['checkbox-batch'] : styles['checkbox-common']}
                    // disabled={!batchActive && (isChangingQty || stockNum === 0)}
                />
            </div>

            {!!tag && (
                <OrderProductTag tag={tag} absolute={false}/>
            )}

            {!!tips && <div className={styles.tips}>{tips}</div>}
        </div>
    )
};
